export default "__VITE_ASSET__k5WRC4ds__"